import { render, staticRenderFns } from "./PersonWidgetWrapper.vue?vue&type=template&id=5d3718d7&scoped=true&"
import script from "./PersonWidgetWrapper.vue?vue&type=script&lang=ts&"
export * from "./PersonWidgetWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PersonWidgetWrapper.vue?vue&type=style&index=0&id=5d3718d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3718d7",
  null
  
)

export default component.exports